var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPenEdit = function SvgPenEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5489 13.8668C14.5489 14.5674 13.9795 15.1583 13.2789 15.1583H3.11687C2.41628 15.1583 1.84691 14.5674 1.84691 13.8668V3.70477C1.84691 3.00418 2.41628 2.45549 3.11687 2.45549H9.04441V1.60938H3.11687C1.94949 1.60938 1 2.53819 1 3.70557V13.8668C1 15.0342 1.94949 16.0044 3.11687 16.0044H13.2781C14.4455 16.0044 15.395 15.0334 15.395 13.8668V7.95997H14.5481V13.8668H14.5489Z",
    fill: "#0F8CFF",
    stroke: "#0F8CFF",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5033 1.48011C14.864 0.839963 13.7483 0.839963 13.1081 1.48011L7.4279 7.16034C7.37383 7.21442 7.33486 7.28281 7.31657 7.35676L6.71857 9.75116C6.68278 9.89509 6.72493 10.0478 6.8299 10.1535C6.91021 10.2339 7.01836 10.2776 7.1289 10.2776C7.16309 10.2776 7.19729 10.2736 7.23148 10.2649L9.62667 9.66607C9.70142 9.64778 9.76902 9.60882 9.82309 9.55474L15.5033 3.87451C15.823 3.55483 15.9995 3.12939 15.9995 2.67691C15.9995 2.22443 15.8238 1.79979 15.5033 1.48011ZM9.30779 8.87324L7.711 9.27244L8.1102 7.67564L12.8091 2.97671L14.0067 4.17431L9.30779 8.87324ZM14.9045 3.27571L14.6055 3.57471L13.4079 2.37712L13.7069 2.07811C14.0266 1.75844 14.5848 1.75844 14.9045 2.07811C15.0644 2.23795 15.1526 2.45028 15.1526 2.67691C15.1526 2.90355 15.0644 3.11587 14.9045 3.27571Z",
    fill: "#0F8CFF",
    stroke: "#0F8CFF",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPenEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/penEdit.6d55b1a1.svg";
export { ForwardRef as ReactComponent };